import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'document'
})
export class DocumentPipe implements PipeTransform {
  transform(value: string): string {
    if(!value){
      return "";
    }
    let formated = (value.replace(/[^0-9]/g, ''));

    switch (formated.length) {
      case 11: // CPF
        return formated.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
      case 14: // CNPJ
        return formated.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
        /**
         * Adequar para cnpj alfa numerico
         *
         * Novo Formato: SS.SSS.SSS / SSSS - NN
         *               RAIZ         ORDEM  DIGITO VERIFICADOR
         * N - Número
         * S - Letra ou Número
         * */
        return formated.replace(
          /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
          "$1.$2.$3/$4-$5"
        );
      default:
        return value;
    }
  }
}
